import React, { useCallback } from 'react';

import { Chip } from '@mui/material';

import { Rate } from '~/services/AccommodationService';

interface CancellationBadgeProps {
  rate: Rate;
  onClick: (rate: Rate) => void;
}

export default function CancellationBadge({ rate, onClick }: CancellationBadgeProps) {
  const handleClick = useCallback(() => {
    onClick(rate);
  }, [onClick, rate]);

  if (rate.refundableStatus === 'refundable') {
    return <Chip label="Refundable" color="success" size="small" onClick={handleClick} />;
  } else if (rate.refundableStatus === 'partially') {
    return <Chip label="Penalties Apply" color="warning" size="small" onClick={handleClick} />;
  } else {
    return <Chip label="Non-refundable" color="default" size="small" onClick={handleClick} />;
  }
}
